import React from "react";
import { Loader2 } from "lucide-react";

const EkycLoader = ({ message = "Preparing verification..." }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        padding: "2rem",
        background: "#ffffff",
      }}
    >
      <Loader2
        size={48}
        style={{
          color: "#667eea",
          animation: "spin 1s linear infinite",
        }}
      />
      
      <p
        style={{
          marginTop: "1.5rem",
          fontSize: "1rem",
          color: "#4b5563",
          fontWeight: "500",
        }}
      >
        {message}
      </p>

      <style>{`
        @keyframes spin {
          from {
            transform: rotate(0deg);
          }
          to {
            transform: rotate(360deg);
          }
        }
      `}</style>
    </div>
  );
};

export default EkycLoader;
